import React from 'react';
import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { ListFiltersLayout as FiltersLayout } from 'framework/list';
import MonthRangeFilter from 'domain/organization/serviceCatalog/kpi/List/filter/MonthRangeFilter';

type KpiStructureStaticFiltersProps = {
  title?: React.ReactNode;
  sx?: SxProps<Theme>;
};

const KpiValuesStaticFilters = ({ title, sx = {} }: KpiStructureStaticFiltersProps) => {
  const filters = (
    <FiltersLayout>
      <MonthRangeFilter source="period" label="Period" canBeInFuture />
    </FiltersLayout>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& [data-testId="remove-btn"], & .filters-reset-btn': {
          display: 'none',
        },
        '.button-dropdown__toggle': {
          minHeight: '36px',
          padding: '5px 12px',
        },
        '.filter-item-wrapper': {
          marginRight: 0,
        },
        ...sx,
      }}
    >
      {title}
      <Box>{filters}</Box>
    </Box>
  );
};

export default KpiValuesStaticFilters;
